import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }


export default /*#__PURE__*/_defineComponent({
  props: {
    label: { default: "" },
    size: { default: "sm" },
    centered: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'd-flex justify-content-center align-items-center gap-2': __props.centered })
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["spinner-border", __props.size === 'sm' ? 'spinner-border-sm' : '']),
      role: "status",
      "aria-hidden": "true"
    }, null, 2),
    (__props.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})